module.exports = __webpack_public_path__ + "img/ch-introduction.63011055.jpg";